import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInbox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useMarkdown } from "@/composables/markdown";
import NotificationActions from "@/components/Notifications/NotificationActions.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MessageNotification',
    props: {
        options: null
    },
    setup(__props) {
        const props = __props;
        library.add(faInbox);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const notificationVariant = computed(() => {
            switch (props.options.notification.variant) {
                case "urgent":
                    return "danger";
                default:
                    return props.options.notification.variant;
            }
        });
        return { __sfc: true, props, renderMarkdown, notificationVariant, faInbox, FontAwesomeIcon, NotificationActions };
    }
});
